import { useMemo } from 'react';
import { useTranslation } from '../../../../hooks/useTranslation';
import { doesBooleanMatchSearch } from './doesBooleanMatchSearch';

type UseBooleanOptionsProps = {
  search: string;
};

export const useBooleanOptions = ({ search }: UseBooleanOptionsProps) => {
  const { t } = useTranslation();
  return useMemo(
    () =>
      [true, false]
        .map((bool) => ({
          title: t(`v2.conditionBuilder.boolean.${bool}`),
          value: bool.toString(),
        }))
        .filter((option) => doesBooleanMatchSearch(option.title, search)),
    [t, search],
  );
};
